import Vue from 'vue'

import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'

Vue.use(VueFilterDateFormat)
